import { AppLayout, TeamCard, TeamHero } from '@components'
import { GetStaticProps, NextPage } from 'next'
import { queryTeam } from '@queries'
import { getGraphQLData } from 'database/graphQL/apollo'
import { ITeamMember, ITeam } from '@types'
import { NextSeo } from 'next-seo'

export const getStaticProps: GetStaticProps = async () => {
  const response = await getGraphQLData<{ allTeams: ITeam[] }>(queryTeam)

  return {
    props: { teamData: response.allTeams },
    revalidate: 10,
  }
}
const Team: NextPage<{
  teamData: ITeam[]
}> = ({ teamData }) => {
  return (
    <AppLayout>
      <NextSeo
        title={'Team'}
        description="With a diverse team of experienced professionals spanning 5 continents, MarketX Ventures remains committed to supporting a global network of world-changing companies."
        canonical={'https://www.marketxventures.com/team'}
        openGraph={{
          title: `Team | MarketX Ventures`,
          url: 'https://www.marketxventures.com/team',
        }}
      />
      <TeamHero />
      {teamData.map((team: ITeam, teamIndex: number) => {
        return team.members?.length ? (
          <div
            className={`container mx-auto px-5 lg:px-56 ${
              teamIndex === 0 ? 'pt-5 lg:pt-10' : ''
            } `}
            key={teamIndex}>
            {team.title && (
              <h2
                className={`mt-12 pb-5 text-center text-xl font-bold text-themeBlack lg:mt-[52px] lg:text-4xl`}>
                {team.title}
              </h2>
            )}

            {team.intro && (
              <p className="mx-auto w-full text-center text-base font-normal text-themeBlack lg:w-[83%] lg:text-lg 2xl:w-[69%]">
                {team.intro}
              </p>
            )}
            <div className="mt-8">
              <div
                className={`flex flex-col flex-wrap items-center justify-center md:flex-row md:items-start`}>
                {team?.members?.map(
                  (member: ITeamMember, memberIndex: number) => {
                    return (
                      <div
                        className={`mb-12 w-3/4 px-5 md:w-1/2 xl:w-1/3`}
                        key={memberIndex}>
                        <TeamCard
                          image={member?.photo?.url || ''}
                          name={member.firstName + ' ' + member.lastName}
                          position={member?.title || ''}
                          linkedIn={member?.linkedin || ''}
                          slug={member.slug}
                        />
                      </div>
                    )
                  },
                )}
              </div>
            </div>
          </div>
        ) : (
          <div key={teamIndex} />
        )
      })}
    </AppLayout>
  )
}

export default Team
